import { useEffect } from 'react';
import { downloadString, downloadFile, printState } from './DownloadString';
import { OneMapApiDataService } from '../model/OneMapApiDataService';
import { tableDataMapping, tableDataMappingOrdered, jsonToCSVDownloadString } from '../model/DataTransformation';
import TableGridColumns from '../model/TableColumns';

//ΔVΔVΔ: Just a demo of use
const DummyDownloader = () => {
    const dummyData = Object.values({
        template: { width: 200, minWidth: 50, hide: true, description: '', headerName: '' },
        Theme1_EP_POV: { width: 200, minWidth: 50, description: 'Percentage of persons below poverty', headerName: 'EP_POV' },
        Theme1_MP_POV: { width: 200, minWidth: 50, description: 'Percentage of persons below poverty estimate margin of error', headerName: 'MP_POV' },
        Theme1_EP_UNEMP: { width: 200, minWidth: 50, description: 'Unemployment Rate', headerName: 'EP_UNEMP' },
        Theme1_MP_UNEMP: { width: 200, minWidth: 50, description: 'Unemployment Rate  estimate margin of error', headerName: 'MP_UNEMP' },
        Theme1_EP_PCI: { width: 200, minWidth: 50, description: 'Per capita income estimate', headerName: 'EP_PCI' }
    });
    return <Downloader filename={'dummy_download.csv'} json={dummyData} />;
};
export { DummyDownloader };

// ΔVΔVΔ: Component that downloads data when the json changes
const Downloader = (props) => {
    const { triggerDownload, onDownload, onDownloadDoc, filename, dataProps, year } = props;

    //download props empty when tab is map
    useEffect(() => {
        //ΔVΔVΔ: Runs when Json or filename is updated in props
        if (!triggerDownload) return;
        loadJsonForDownload(dataProps).then((json) => {
            const isLive = window.location.href.indexOf('https://www.atsdr.cdc.gov/') === 0;
            downloadFile(isLive ? year.docs : year.localdoc, year.filename, onDownloadDoc);
            downloadCSV(json, filename, onDownload);
        });
    }, [triggerDownload]);
    return null;
};
export { Downloader };

const loadJsonForDownload = async (props) => {
    const DS = new OneMapApiDataService();
    const clonedp = Object.assign({}, props, { usState: props.csvState });
    return DS.getTableData(clonedp).then((res) => {
        const tableColumns = TableGridColumns[props.year == '2020' ? '2020' : 'before2020'];
        return tableDataMappingOrdered(res, tableColumns);
    });
};
// ΔVΔVΔ: Filename will be download.csv
const downloadCSV = (json, filename = 'download.csv', onDownload = () => {}) => {
    //ΔVΔVΔ: Support # and " within values
    let csvLink = jsonToCSVDownloadString(json);
    downloadString(csvLink, filename, false, (link) => {
        onDownload(link); //use to prevent re-download
    });
    return null;
};
export { downloadCSV };
